export function isNotUndefined<T>(value: T | undefined): value is T {
  return value !== undefined;
}

export const isNotNull = <T>(value: T | null): value is T => value !== null;

export const isNotNullOrUndefined = <T>(
  value: T | null | undefined
): value is T => {
  return value !== null && value !== undefined;
};

// Replace fields to a contentful type
export type ReplaceFields<T, U> = T extends { fields: infer F }
  ? Omit<T, 'fields'> & { fields: U & Omit<F, keyof U> }
  : T;

// For debugging: will take a combined type and flatten to see in intellisense
export type Expand<T> = T extends infer O ? { [K in keyof O]: O[K] } : never;

export type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P];
};
